import { apiMiddleware } from 'redux-api-middleware';
import { loadableReady } from '@loadable/component';
import Localytics, { CUSTOM_DIMENSIONS } from '../lib/utils/localytics';
import ReactCriteo from '../lib/utils/criteo';
import ReactGTM from '../lib/utils/gtm';
import Router from '../common/components/Router';
import entryPoint from './renderEntryPoint';
import hot from './hot-loader';

if (window) {
  const {
    analytics, // TODO: can't de-structure this into 'analyticsConfig' because sometimes analytics is undefined
    auth,
    user,
    config,
  } = window.PreloadedState;

  if (analytics) {
    if (analytics.localytics) {
      const llOptions = {
        domain: 'gasbuddy.com',
        customDimensions: [],
      };

      if (auth && auth.account_id) {
        llOptions.customDimensions[CUSTOM_DIMENSIONS.USER_ID] = auth.account_id;
      }

      Localytics.initialize(analytics.localytics, llOptions);

      if (user && user.name) {
        Localytics.identifyUser(user.name);
        Localytics.setCustomDimension(CUSTOM_DIMENSIONS.USER_NAME, user.name);
      }
    }

    if (analytics.criteo) {
      ReactCriteo.initialize(analytics.criteo);
    }

    if (analytics.gtm) {
      ReactGTM.initialize(analytics.gtm, auth && auth.account_id);
    }
  }
  // https://webpack.js.org/guides/public-path/#on-the-fly
  // eslint-disable-next-line babel/camelcase, no-undef
  __webpack_public_path__ = config.publicPath;
}

const render = () => entryPoint({
  router: hot(Router),
  initialState: window.PreloadedState,
  apiMiddleware,
});

loadableReady(() => {
  render();
});
